export const DefaultLittleMessage = '-';
